import React, { Component, useState } from "react";
import {
    createStyles,
    makeStyles,
    Theme,
    ThemeProvider,
} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { CategoryTreeView } from "../CategoryTree/CategoryTreeView";
import DialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import theme from "js/material-ui-theme";
import { CategoriaProduto } from "@idha/idha-types/dist/orders/CategoriaProduto";
import { useMediaQuery } from "@material-ui/core";

export type CategoryTreeDialogProps = {
    categorias: CategoriaProduto[];
    open: boolean;
    enableAllNodesForSelection?: boolean;

    setCategoria: (value: CategoriaProduto) => void;
    onClose: () => void;
};
export const CategoryTreeDialog = (props: CategoryTreeDialogProps) => {
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("xs"));

    const [categoriaProduto, setCategoriaProduto] = useState<CategoriaProduto>(
        null
    );

    const classes = useStyles();

    return (
        <ThemeProvider theme={theme}>
            <div>
                <Dialog
                    open={props.open}
                    onClose={() => {
                        props.onClose();
                    }}
                    maxWidth="sm"
                    fullWidth={true}
                >
                    <div
                        style={{ display: "flex", backgroundColor: "#00897b" }}
                    >
                        <p className={classes.root}>Selecione a categoria</p>
                        <Button
                            className={classes.closeButton}
                            onClick={() => {
                                props.onClose();
                            }}
                        >
                            <CloseIcon />
                        </Button>
                    </div>

                    <DialogContent>
                        <CategoryTreeView
                            enableAllNodesForSelection={
                                props.enableAllNodesForSelection
                            }
                            categorias={props.categorias}
                            setCategoria={setCategoriaProduto}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                props.onClose();
                            }}
                            color="default"
                        >
                            CANCELAR
                        </Button>
                        <Button
                            onClick={() => {
                                props.setCategoria(categoriaProduto);
                                props.onClose();
                            }}
                            color="primary"
                        >
                            SELECIONAR
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </ThemeProvider>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            fontSize: "20px",
            color: "white",
            paddingTop: "10px",
            paddingLeft: "8px",
            flex: "12",
        },
        closeButton: {
            color: "white",
            fontSize: "15px",
            flex: "auto",
        },
    })
);
